import $http from '$http';
import {
    cloneDeep,
    util,
    isCorrectVal,
    isDate,
    lg
} from 'utils';
import {
    GetParmConfig, //寄送，支付接口
} from '@api/commonApi.js';
export default {
    methods: {

        getList(orderId) {
            let params = {
                Sid: this.$store.state.sysSid,
                Session: this.$store.state.sysSession,
                OrderId: orderId
            };
            $http.get("api/ContinueOrder/GetContinueOrderById", params).then(res => {
                jToast.close();
                this.AddDialogVisible = true;
                let {
                    Data,
                    Cnt
                } = res.data;
                this.loading = false;
                util.doResult(this, res, () => {
                    this.form = Data
                    this.form.PackageList = Data.ProList[0].List
                    this.GoodsListNum = Data.ProList
                    if (this.form.PackageId == 405) {
                        for (let i = 0; i < this.GoodsListNum.length; i++) {
                            this.GoodsListNum[i].List[0].title = '配置美师英语学习材料包'
                            this.GoodsListNum[i].List[1].title = '配置思维导图学习材料包'
                            this.GoodsListNum[i].List[2].title = '配置艺术亲子活动材料包'
                        }
                    }
                    for (let i = 0; i < this.form.ListMeetPay.length; i++) {
                        let pic = this.form.ListMeetPay[i].VoucherPic.split(',')
                        this.form.ListMeetPay[i].changePic = []
                        for (let j = 0; j < pic.length; j++) {
                            this.form.ListMeetPay[i].changePic.push({
                                "Url": pic[j]
                            })
                        }
                    }

                    // 代理商主联系人，代理商公司，代理商所在区域，代理商联系电话
                    this.agent = Data.C_Name + '  ' + Data.AgentName + '  ' + Data.ShortAddress + '  ' + Data.C_Tel
                    //园所名称，园长姓名及园长电话
                    this.school = Data.SchoolName + '  ' + Data.PrincipalName + '  ' + Data.PrincipalPhoneNo
                    //收货地址
                    this.ConsigneeList = Data.SchoolProvName + '  ' + Data.SchoolCityName + '  ' + Data.SchoolAreaName + '  ' + Data.SchoolAddress
                    //联系人及电话
                    this.ConsigneeListName = Data.SchoolConsignee + '  ' + Data.SchoolConsigneeTel

                });
            });
        },


    }
}


// WEBPACK FOOTER //
// ./src/pages/SchoolOrder/BookPackage/OrderView/services.js